import { Box, Container, IconButton, Link, Typography, useTheme } from '@mui/material'
import React from 'react'
import CopyrightIcon from '@mui/icons-material/Copyright';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';


const Footer : React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'sticky',
        top: '0',
        boxShadow: `0px -10px 40px ${theme.palette.primary.light}`,
        background: `${theme.palette.background.default}F2`,
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 32px',
        }}
      >
        <Typography
          variant='body1'
          sx={{ display: 'flex', alignItems: 'end', margin: '0 0 4px 0' }}
        >
          Copyright <CopyrightIcon sx={{ padding: '0px 2px 0px 2px' }} /> 2023
        </Typography>
        <Typography
          variant='body1'
          sx={{ display: 'flex', alignItems: 'start' }}
        >
          All Rights Reserved
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Link
            href={'https://github.com'}
            target={'_blank'}
          >
            <IconButton>
              <GitHubIcon />
            </IconButton>
          </Link>
          <Link
            href={'https://linkedin.com'}
            target={'_blank'}
          >
            <IconButton
              onClick={() => {
                // NOTE: method 1
                // redirects current window to url
                // window.location.href = 'https://linkedin.com';

                // NOTE: method 2
                // opens new tab with url
                // window.open('https://linkedin.com', '_blank');

                // NOTE: method 3; can also create an anchor tag to open a new tab
                // // create the element and assign values to the props
                // const link = document.createElement('a')
                // link.href = 'https://linkedin.com';
                // link.target = '_blank';

                // // add the element to the dom
                // document.body.appendChild(link)

                // // programatticallyclick the link to
                // link.click()

                // // remove the element
                // if (link.parentNode !== null) {
                //   link.parentNode.removeChild(link);
                // }
              }}
            >
              <LinkedInIcon />
            </IconButton>
          </Link>
          <Link
            href={`mailto:${process.env.REACT_APP_GOOGLE_EMAIL}?subject=Message About Your Personal Website`}
            target={'_blank'}
          >
            <IconButton>
              <EmailIcon />
            </IconButton>
          </Link>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer